/**
 * Función para aplicar la variación DRC a un peso seco
 * @param {*} pesoSeco - Peso del plato
 * @param {*} pesoPlato - Peso húmedo
 * @param {*} variacionDRC - Variación DRC en porcentaje
 * @returns {number} - Peso plato ajustado con variación DRC
 */
export const aplicarVariacionDRC = (pesoSeco, pesoPlato, variacionDRC) => {
    // Validar que todos los parámetros sean números válidos
    if (!pesoSeco || !pesoPlato || !variacionDRC || 
        isNaN(pesoSeco) || isNaN(pesoPlato) || isNaN(variacionDRC)) {
        return 0;
    }
    const AjustePesoPlato = pesoSeco - pesoPlato;
    
    const variacionAplicada = AjustePesoPlato * (variacionDRC / 100);

    const pesoPlatoAjustado = pesoPlato + variacionAplicada;
    
    return pesoPlatoAjustado;
}

/**
 * Función para aplicar la variación DRC a un peso seco
 * @param {*} pesoSeco - Peso del plato
 * @param {*} variacionDRC - Variación DRC en porcentaje
 * @returns {number} - Peso seco ajustado con variación DRC
 */
export const aplicarVariacionDRCSolidos = (pesoSeco, variacionDRC) => {
    // Validar que todos los parámetros sean números válidos
    if (!pesoSeco || !variacionDRC || 
        isNaN(pesoSeco) || isNaN(variacionDRC)) {
        return 0;
    }
    const variacionAplicada = pesoSeco * (1 - (variacionDRC / 100));

    return variacionAplicada;
}


/**
 * Función para obtener el color de la variación DRC
 * @param {*} valor - Valor de la variación DRC
 * @returns {string} - Clase de color
 */
export const getColorVariacionDRC = (valor) => {
    if (valor > 0) {
        return 'text-danger font-weight-bold';
    } else if (valor < 0) {
        return 'text-primary font-weight-bold';
    } else {
        return '';
    }
}
